<template>
   <v-dialog v-model="show" :persistent="false" width="550px">
      <v-card>
        <v-card-title>
          <span :class="`title1`">{{ $t('USER-CHANGE-PASSWORD-DIALOG-TITLE') }}</span>
          <v-spacer></v-spacer>
          <v-btn icon light @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn> 
        </v-card-title>
        <v-form
            ref="passwordForm"
            v-model="validPasswordForm"
            lazy-validation
          >
        <v-card-text> 
          <password-field
              v-model="model.password"
              label="USER-LABEL-PASSWORD-NEW"
            ></password-field>
            <v-text-field
              :rules="[rules.required, passwordConfirmationRule]"
              v-model="model.rePassword"
              type="password"
              :label="$t('USER-LABEL-PASSWORD_NEW-REPEAT')"
              required
            ></v-text-field>

        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="close" :disabled="loading">{{ $t('GLOBAL-BTN-CANCEL') }}</v-btn>
            <v-btn elevation="0" light rounded color="themeColor" @click="changePassword" :loading="loading"
              >{{ $t('GLOBAL-BTN-CHANGE_PASSWORD') }}</v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
  </v-dialog>
  
</template>

<script>
import ConfirmDialog from '../ui-elements/ConfirmDialog.vue';
import passwordField from "@/components/PasswordField";
import {cloneDeep} from 'lodash';

  export default {
    name: 'UserChangePasswordDialog',
    components: {ConfirmDialog, passwordField},
    props:{
      visible: {
        type: Boolean,
        default: false
      },
      user:{
        type: Object,
        required: true
      }
    },
    data(){
      return {
        loading: false,
        show: false,
        validPasswordForm: false,
        model: {
          id: 0,
          name: '',
          password: '',
          rePassword: '',
        },
        defaultModel: {
          id: 0,
          name: '',
          password: '',
          rePassword: '',
        }
      }
    },
    watch:{
      visible:{
        handler(status){
          this.show = status;
          if(!status) return;
          this.model = cloneDeep(this.user);
          if(this.$refs.passwordForm){
            this.$refs.passwordForm.resetValidation();
          }
        }
      },
      show:{
        handler(value){
          if(value) return;
          this.close();
        }
      }
      
    },
    methods:{
      passwordConfirmationRule() {
        return (
          this.model.password === this.model.rePassword ||
          this.$t("GLOBAL-FORM-PASSWORDS_MUST_MATCH")
        );
      },
      close(){
        this.model = cloneDeep(this.defaultModel);
        this.$emit('close');
      }, 
      changePassword(){
        if(!this.model || !this.model.id) throw new Error('Missing required user id!');
        if (!this.$refs.passwordForm.validate()) {
          return false;
        }
        this.loading = true;
        this.axios
          .post(`user/${this.model.id}/changePassword`, {
            new_password: this.model.password,
          })
          .then((res) => {
            this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL-MESSAGE-PASSWORD_SUCCESSFULLY_CHANGED"),
            });
            this.close();
          })
          .catch((error) => {
            console.error(error.response);
            this.$store.dispatch("setSnackbar", {
              text: error.response.data.message,
              type: "error",
            });
          }).finally(() =>{
            this.loading = false;
          });
      }
    }
    
  }
</script>

<style lang="scss" scoped>

</style>
